module.exports = __webpack_public_path__ + "img/Album1.64d2f0cc.jpg";